
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/myevents",
      function () {
        return require("private-next-pages/myevents/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/myevents"])
      });
    }
  